import React from 'react';
import { InternetForm } from '../form/InternetForm';
import { useInternetCalculator } from '../InternetCalculatorProvider';
import { InternetTelia1PromoModal } from './InternetTelia1PromoModal';
import { InternetDetails } from './InternetDetails';
export const InternetDetailsModal = () => {
    const { modalState } = useInternetCalculator();
    if (!modalState.offer) {
        return null;
    }
    if (modalState.showTelia1PromoModal) {
        return React.createElement(InternetTelia1PromoModal, { offer: modalState.offer });
    }
    return modalState.showForm ? React.createElement(InternetForm, { offer: modalState.offer }) : React.createElement(InternetDetails, { offer: modalState.offer });
};
